module.exports = __webpack_public_path__ + "static/media/4ODA5.c3bcb33c.jpg";